var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form"]
var hoisted2 = ["class", "text-danger"]
var hoisted3 = ["class", "form-group"]
var hoisted4 = ["for", "name"]
var hoisted5 = ["class", "input-group"]
var hoisted6 = ["type", "text", "id", "name", "class", "form-control", "focus", "", "required", ""]
var hoisted7 = ["class", "input-group-btn"]
var hoisted8 = ["type", "button", "class", "btn btn-default"]
var hoisted9 = ["class", "fa fa-arrow-up"]
var hoisted10 = ["type", "button", "class", "btn btn-default"]
var hoisted11 = ["class", "fa fa-arrow-down"]
var hoisted12 = ["type", "button", "class", "btn btn-default"]
var hoisted13 = ["class", "fa fa-plus"]
var hoisted14 = ["type", "button", "class", "btn btn-default dropdown-toggle", "data-toggle", "dropdown", "title", "More actions"]
var hoisted15 = ["class", "caret"]
var hoisted16 = ["class", "dropdown-menu pull-right"]
var hoisted17 = ["ng1-if", "!dbFinder.model.isKeyReferenced(key)", "class", "divider"]
var hoisted18 = ["ng1-if", "!dbFinder.model.isKeyReferenced(key)"]
var hoisted19 = ["class", "form-group"]
var hoisted20 = ["for", "description"]
var hoisted21 = ["id", "description", "class", "form-control input-sm"]
var hoisted22 = ["class", "form-group"]
var hoisted23 = ["for", "type"]
var hoisted24 = ["id", "type", "class", "form-control input-sm"]
var __target

module.exports = function description (model, root) {
  var keys = model.keys
  elementOpen("form", "08c714bd-ab48-4bea-9d69-71453f43bb64", hoisted1)
    if (model.errors.length) {
      elementOpen("ul", "d9cfbf48-6c1d-4b7a-8cdb-a6213f86885b", hoisted2)
        __target = model.errors
        if (__target) {
          ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
            var item = $value
            var $key = "759f53ce-a4fa-41f6-b092-2d204a99e97b_" + $item
            elementOpen("li", $key)
              text(" \
                      " + (item.error) + " \
                    ")
            elementClose("li")
          }, this)
        }
      elementClose("ul")
    }
    elementOpen("div", "6fc83222-c13e-4478-a83a-50fd88737158", hoisted3)
      elementOpen("label", "917d3cfe-3d14-458d-8629-501c17838576", hoisted4)
        text("Key Name")
      elementClose("label")
      elementOpen("div", "e05730f4-2396-4caf-b22a-f51fa24dc46a", hoisted5)
        elementOpen("input", "87d02e79-1762-4ad4-9fef-0fb4373f67b5", hoisted6, "value", model.name, "onchange", function ($event) {
          var $element = this;
        model.name = this.value})
        elementClose("input")
        elementOpen("div", "f563d99a-231d-4c55-be6c-a4c25ffb3040", hoisted7)
          elementOpen("button", "feb99943-2239-4ec8-89f2-76e01736e885", hoisted8, "onclick", function ($event) {
            var $element = this;
          keys.moveKeyUp(model)}, "title", "Move key [" + (model.name) + "] up")
            elementOpen("i", "03ff61aa-233f-4ad3-be23-1e9d2bb5c0f8", hoisted9)
            elementClose("i")
          elementClose("button")
          elementOpen("button", "4e899b13-52f7-4ea1-be2b-a026a9e3ff05", hoisted10, "onclick", function ($event) {
            var $element = this;
          keys.moveKeyDown(model)}, "title", "Move key [" + (model.name) + "] down")
            elementOpen("i", "403e682e-8c73-4fdb-a3f6-eca9997179b5", hoisted11)
            elementClose("i")
          elementClose("button")
          elementOpen("button", "da36e2f5-061b-40e6-9c1f-1b065873c69c", hoisted12, "onclick", function ($event) {
            var $element = this;
          root.currentItem = keys.insertKey(model.index + 1)}, "title", "Add key below [" + (model.name) + "]")
            elementOpen("i", "19bf0625-4826-43f0-8a86-b4f050748528", hoisted13)
            elementClose("i")
          elementClose("button")
          elementOpen("button", "a8dc05e7-3fd6-4f71-9646-715844d0a8c2", hoisted14)
            elementOpen("span", "b6f95f64-04e5-4290-8fd5-8114508f19ec", hoisted15)
            elementClose("span")
          elementClose("button")
          elementOpen("ul", "b691ff06-8991-4270-8788-18d8622cb4f8", hoisted16)
            elementOpen("li")
              elementOpen("a", null, null, "onclick", function ($event) {
                var $element = this;
              root.currentItem = keys.insertKey(model.index + 1)})
                text("Add key below [" + (model.name) + "]")
              elementClose("a")
            elementClose("li")
            elementOpen("li")
              elementOpen("a", null, null, "onclick", function ($event) {
                var $element = this;
              root.currentItem = keys.insertKey(model.index)})
                text("Add key above [" + (model.name) + "]")
              elementClose("a")
            elementClose("li")
            elementOpen("li", "db7ec426-99d0-4288-b734-ea0ddfebc857", hoisted17)
            elementClose("li")
            elementOpen("li", "e42376a3-f79b-4505-8ee7-988165bb3d82", hoisted18)
              elementOpen("a", null, null, "onclick", function ($event) {
                var $element = this;
              keys.deleteKey(model); root.currentItem = model.owner})
                text("Delete key [" + (model.name) + "]")
              elementClose("a")
            elementClose("li")
          elementClose("ul")
        elementClose("div")
      elementClose("div")
    elementClose("div")
    elementOpen("div", "07e4a3e3-93ba-4f62-a2bb-f484335ccc06", hoisted19)
      elementOpen("label", "9c5a88f8-0fa0-43c5-bbf1-a2b5596075f8", hoisted20)
        text("Key Description")
      elementClose("label")
      elementOpen("textarea", "c5156098-90f2-4e9a-9485-d5b5c7de8244", hoisted21, "value", model.description, "onchange", function ($event) {
        var $element = this;
      model.description = this.value})
      elementClose("textarea")
    elementClose("div")
    elementOpen("hr")
    elementClose("hr")
    elementOpen("div", "8d069036-81d8-40b2-bb12-dbbf7e9e7cb9", hoisted22)
      elementOpen("label", "19bc2439-a44c-45c0-84ff-b4c6384c2ff9", hoisted23)
        text("Type")
      elementClose("label")
      elementOpen("select", "3b5fd540-c66e-4ef0-8fa1-3658973cab2a", hoisted24, "value", model.type, "onchange", function ($event) {
        var $element = this;
      model.type = this.value})
        __target = root.staticTypes
        if (__target) {
          ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
            var type = $value
            var $key = "75335981-92b0-43dd-9372-9b5d9fb9c1a8_" + $item
            elementOpen("option", $key, null, "value", type, "selected", model.type === type ? 'selected' : null)
              text("" + (type) + "")
            elementClose("option")
          }, this)
        }
      elementClose("select")
    elementClose("div")
    var defsView = require('./defs.html')
          defsView(model.type, model.def, root)
  elementClose("form")
}
